module.exports = __webpack_public_path__ + "static/media/56.8ea3183f.jpg";